import svSvgIcon from './sv-svg-icon.vue'
export default svSvgIcon